import { setRemoteDefinitions } from '@nx/angular/mf';
// import { environment } from '@env/environment';

function processManifestDefinitions(definitions: any) {
  const isLocalDev = window.location.port !== '';
  // const isCDN = environment.CDN;
  let baseUrl = '';
  // if(isCDN){
  //   baseUrl = `${window.location.protocol}//static-${window.location.host}`;
  // }else{
    baseUrl = isLocalDev ? `${window.location.protocol}//${window.location.hostname}` : `${window.location.protocol}//${window.location.host}`;
  // }

  for (const mfeName in definitions) {
    const [mfeValue, port] = definitions[mfeName].split(':');

    if (isLocalDev) {
      definitions[mfeName] = `${baseUrl}:${port}`;
    } else {
      definitions[mfeName] = `${baseUrl}/${mfeValue}`;
    }
  }

  return definitions;
}

fetch('/assets/module-federation.manifest.json')
  .then((res) => res.json())
  .then((definitions) => setRemoteDefinitions(processManifestDefinitions(definitions)))
  .then(() => import('./bootstrap').catch((err) => console.error(err)));